<template>
  <div id="newForword">
    <header>
      <div class="title">
        <img :src="logoUrl" alt="" @click="goIndex">
      </div>
      <p class="sysName"> 
        <span :class="headClass">{{companyName}}</span>
        <span v-if="sys" class="sys">{{systemDescribe}}</span>
      </p>
      <h4 @dblclick="dialogSubDetails = true" title="该位置只显示3条子账，如最后显示省略号则代表有部分子账没有显示完全，如需全部子账业务，可以双击该段文字进行查看。">{{title}}</h4>
      <p style="font-size:12px;">{{ userName }}</p>
      <div class="hint">
        <el-button type="primary" size="mini" @click="changeLayout" v-if="!dis">切换老布局</el-button>
        <el-button type="primary" size="mini" @click="changeVersions" v-if="!dis">切换老版本</el-button>
        <el-button type="primary" size="mini" @click="back">重选远期业务</el-button>
        <el-button type="primary" size="mini" @click="dialogVisible = true">提示信息</el-button>
      </div>
    </header>
    <div class="infoStatus">
      <el-table :data="datas" border background :height="50">
        <el-table-column prop="" label="动态权益">
          <template>
            <span :class="isClass(dynPrifit())"> {{ thousands(dynPrifit()) }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="保证金">
          <template slot-scope="scope">
            <span :class="isClass(scope.row.margin)"> {{ thousands(scope.row.margin) }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="持盈">
          <template slot-scope="scope">
            <span :class="isClass(scope.row.float)"> {{ thousands(scope.row.float) }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="平盈">
          <template slot-scope="scope">
            <span :class="isClass(scope.row.closeProfit)"> {{ thousands(scope.row.closeProfit) }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="余额">
          <template slot-scope="scope">
            <span :class="isClass(scope.row.usable)"> {{ thousands(scope.row.usable) }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="风险度">
          <template>
            <span :class="isClass(risk())"> {{ risk() }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="冻结资金">
          <template slot-scope="scope">
            <span :class="isClass(scope.row.freezeMargin)"> {{ thousands(scope.row.freezeMargin) }} </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content">
      <nav>
        <left_exchange></left_exchange>
      </nav>
      <section>
        <for_content @newPrice="getNewPrice" @get:forwardconfig="getForward"></for_content>
      </section>
      <section>
        <right_details :configs="forwardconfigs"></right_details>
      </section>
      
    </div>
    <div class="cc">
      <div class="head">
        <span style="padding: 0 10px;margin-left:5px;" @click="all" :class="[isActive == 'for_allCC'?'active':'']">当前合约持仓汇总</span>
        <span style="padding: 0 10px;margin-left:5px;" @click="details" :class="[isActive == 'for_cc'?'active':'']">当前合约持仓明细</span>
        <span style="padding: 0 10px;margin-left:5px;" @click="entrustNow" :class="[isActive == 'for_entrustNow'?'active':'']">当前委托</span>
        <span style="padding: 0 10px;margin-left:5px;" @click="entrustHis" :class="[isActive == 'for_entrustHis'?'active':'']">历史委托</span>
        <span style="padding: 0 10px;margin-left:5px;" @click="mab" :class="[isActive == 'for_mab'?'active':'']">成交信息</span>
        <el-button type="primary" @click="daochuCC" size="mini" style="float:right;margin-top:1px;" :disabled="daochuCCFlag">导出</el-button>
        <el-button type="primary" @click="compileCC" size="mini" style="float:right;margin-top:1px;margin-right:5px;" :disabled="!id">编辑</el-button>
      </div>
      <component :is="isActive" :subNos="subNos" :socketData="socketData" :tradingDay="tradingDay" :height="height" :showData="innerShowData"></component>
    </div>
    <!-- <div class="entrust">
      <div class="head">
        <span style="padding: 0 10px;margin-left:5px;" @click="entrustNow" :class="[isActive == 'for_entrustNow'?'active':'']">当前委托</span>
        <span style="padding: 0 10px;margin-left:5px;" @click="entrustHis" :class="[isActive == 'for_entrustHis'?'active':'']">历史委托</span>
        <span style="padding: 0 10px;margin-left:5px;" @click="mab" :class="[isActive == 'for_mab'?'active':'']">成交信息</span>
        <el-button type="primary" @click="daochuEntrust" size="mini" style="float:right;margin-top:1px;" :disabled="daochuEntrustFlag">导出</el-button>
        <el-button type="primary" @click="compileEntrust" size="mini" style="float:right;margin-top:1px;margin-right:5px;" :disabled="!id">编辑</el-button>
      </div>
      <component :is="isActive" :subNos="subNos" :showData="orderShowData"></component>
      
    </div> -->

    <exchange_socket></exchange_socket>

    <!-- dialog -->
      <el-dialog title="提示" :visible.sync="dialogVisible" width="50%">
        <p style="text-align:center;">操作提示：</p>
        <p v-if="dis">0、标题只显示三个子账，如你所有的子账多余三个。可双击查看全部子账。(只会在不需要交易的情况下显示多个子账)</p>
        <p>1、在输入框中输入代码后按回车键即可进行精确查询</p>
        <P>2、鼠标双击即可进行快速下单</P>
        <P>3、鼠标右键点击即可快速加入自选</P>
        <p>4、选中标的后行情右侧会显示该标的的详细信息</p>
        <p style="text-align:center;">字段解释与计算公式</p>
        <P>1、持仓明细中：持仓市值 = 持仓手数 * 合约乘数 * 最新价</P>
        <P>2、浮动盈亏是总的浮动盈亏。买 + 卖 </P>
        <p> 2.1、买持仓盈亏（逐笔）= 持仓手数 * 最新价 * 合约乘数 - 买期初成交价持仓市值(逐笔) </p>
        <p> 2.2、卖持仓盈亏（逐笔）= 买期初成交价持仓市值(逐笔) - 持仓手数 * 最新价 * 合约乘数 </p> 
        <p> 2.3、买持仓盈亏（盯市）= 最新价 * 持仓数量 * 合约乘数 - 买持仓市值(盯市) </p>
        <p> 2.4、卖持仓盈亏（盯市）= 买持仓市值(盯市) - 最新价 * 持仓数量 * 合约乘数 </p> 
        <!-- <p>8、净头持仓成本 = 多头与空头之间的轧差 * 持仓均价(多边均价)</p> -->
        <p>3、买/卖持仓市值(盯市): </p>
        <p>3.1、今日开仓: 成交价 * 数量</p>
        <p>3.2、历史仓: 前结算价 * 数量</p>
        <p>4、平仓盈亏是总的盈亏</p>
        <p>5、成交信息中手续费显示的是总的手续费（平仓+开仓），该手续费只有历史单才会有</p>
        <p>6、动态权益=资金余额+浮动盈亏+冻结保证金</p>
        <p>7、保证金: </p>
        <p>7.1、历史仓 = 前结算价 * 手数 * 保证金率</p>
        <p>7.2、今仓 = 成交价 * 手数 * 保证金率</p>
        <!-- <p>静态权益=资金余额+盯市持仓盈亏-冻结保证金</p> -->
        <p>8、持盈 = 浮动盈亏</p>
        <p>9、平盈 = 逐日平仓盈亏</p>
        <p>10、余额 = 昨收盘账户余额 + 今日出入金 + 平仓盈亏 - 冻结保证金</p>
        <p>11、风险度 = (持仓保证金 + 冻结保证金) / 动态权益</p>
        <p>12、冻结资金 = 委托单 * 保证金率</p>
        <p style="color: red;">每个子账下业务都是独立的</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 验证交易密码 -->
      <el-dialog :close-on-click-modal="false" title="请输入交易密码" :visible.sync="dialogPassword" width="50%" :before-close="handlerClose">
        <el-input v-model="tradePassword" type="password" placeholder="请输入交易密码" @keyup.native.enter="checkPass"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="checkPass">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 查看全部子账 -->
      <el-dialog :close-on-click-modal="false" title="查看全部子账" :visible.sync="dialogSubDetails" width="50%" :before-close="handlerClose">
        <p> {{ allTitle }} </p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogSubDetails = false">确 定</el-button>
        </span>
      </el-dialog>
  </div> 
</template>

<script>
import left_exchange from '@/components/new-layout-forword/left_exchange'
import right_details from '@/components/new-layout-forword/right_details'
import for_content from '@/components/new-layout-forword/for_content'
import for_cc from '@/components/new-layout-forword/for_cc'
import for_allCC from '@/components/new-layout-forword/for_allCC'
import for_entrustNow from '@/components/new-layout-forword/for_entrustNow'
import for_entrustHis from '@/components/new-layout-forword/for_entrustHis'
import for_mab from '@/components/new-layout-forword/for_mab'

import exchange_socket from '@/components/new-layout-forword/exchangeSocket'

import bus from '@/assets/eventBus'
import g from '@/components/Global'
import GlobalConfig from '@/components/Global.config.vue'
import axios from '@/axios'
import { Base64 } from 'js-base64'
export default {
  name:'newLayoutForword',
  data(){
    return {
      dialogVisible: false,
      dialogText:true,
      isActive: 'for_allCC',
      daochuEntrustFlag: true,
      daochuCCFlag: true,
      daochuMabFlag: true,
      dialogPassword: false,
      dialogSubDetails: false,
      tradePassword: '',
      ids: '',
      type:'',  //用于区别是下单还是平仓还是撤单
      title: '远期业务',
      allTitle: '',
      subNos: [],
      time: 30000,  //页面定时刷新时间
      socketData: [],   //从content组件中获取最新价格用于实时计算
      tradingDay: '',
      userName: '',   //当前线下账户名称
      forwardconfigs: [],   //远期配置

      detailCCDatas: [],
      allCCDatas: [],

      pageSize: 100,
      height: 300,

      sub: '',
      id: '',
      user: '',
      dis: '',

      datas: [
        {
          positionMargin: 0,    //持仓保证金, 用于结算风险度
          positionProfit: 0,    //盯市持仓盈亏
          closeProfit: 0,
          float: 0,     //浮动盈亏(持仓)
          usable: 0,
          freezeMargin: 0,
          margin: 0,
        }
      ],
      antiShake: true,
      moneyTimer: null,

      positionData: [],     //期权持仓数据
      entrustData: [],      //期权委托数据
      mabData: [],      //期权成交数据
      settlePosition: [],     //盘前持仓

      collectPositionData: [],      //期权汇总持仓数据

      innerShowData: [],
      // orderShowData: [],

      socketObject: null,     //将行情信息格式从数组格式化为对象
      firstPosition: true,

      logoUrl: '',
    }
  },
  destroyed() {
    clearInterval(this.moneyTimer)
  },
  created(){
    // this.getSubNos()
    bus.$on("changeCCFlag", this.changeCCFlag)
    bus.$on("changeEntrustFlag", this.changeEntrustFlag)
    bus.$on("checkPass", this.changeToken)

    // websocket远期订阅推送
    bus.$on("forwordPsuh", this.forwordPsuh)
    // 行情初始获取和推送
    bus.$on("socketArray", this.getSocketArray)
    // 交易日变更情况显示数据
    bus.$on("clearForwordData", this.clearTransactionData)

    this.logoUrl = window.sessionStorage.getItem("logoUrl")
  },
  methods: {
    getHeight() {
      let height = document.documentElement.clientHeight
      if(this.isActive === 'for_allCC' || this.isActive === 'for_cc') {
        this.height = height - 470
      } else {
        this.height = height - 520
      }
    },
    // 持仓,委托,成交推送
    forwordPsuh([name, data]) {
      this[name] = this.clone(data)
    },
    getSocketArray(arr) {
      this.socketData = arr
      let socketObject = {}
      arr.forEach(item => {
        let EU = item.market + '_' + item.code + "_" + this.sub
        socketObject[EU] = item
      })
      this.socketObject = socketObject
    },
    
    // 从content组件中获取最新价格用于实时计算
    getNewPrice(obj){
      this.detectionPriceChange(obj)
    },
    getForward(arr){
      this.forwardconfigs = arr
    }, 
    handlerClose(){
      this.dialogPassword = false
      this.dialogSubDetails = false
      this.tradePassword = ''
    },
    details(){
      this.isActive = 'for_cc'
      this.getHeight()
      this.innerShowData = this.clone(this.positionData).sort( function(x, y) { if(x.contractNo > y.contractNo) { return -1 } if(x.contractNo < y.contractNo) { return 1 } return 0 })
    },
    all(){
      this.isActive = 'for_allCC'
      this.getHeight()
      this.innerShowData = this.clone(this.collectPositionData)
    },
    entrustNow(){
      this.isActive = 'for_entrustNow'
      this.getHeight()
      this.innerShowData = this.clone(this.entrustData)
    },
    entrustHis(){
      this.isActive = 'for_entrustHis'
      this.getHeight()
    },
    mab(){
      this.isActive = "for_mab"
      this.getHeight()
      this.innerShowData = this.clone(this.mabData)
    },
    // daochuEntrust(){
    //   if(this.isActive == 'for_entrustNow') {
    //     bus.$emit('daochuEntrustNow')
    //   } else if(this.isActive == 'for_entrustHis') {
    //     bus.$emit('daochuEntrustHis')
    //   } else if(this.isActive == "for_mab") {
    //     bus.$emit("daochuMab")
    //   }
    // },
    daochuCC(){
      if(this.isActive == 'for_entrustNow') {
        bus.$emit('daochuEntrustNow')
      } else if(this.isActive == 'for_entrustHis') {
        bus.$emit('daochuEntrustHis')
      } else if(this.isActive == "for_mab") {
        bus.$emit("daochuMab")
      } else if(this.isActive == 'for_cc') {
        bus.$emit('daochuCCNow')
      } else if(this.isActive == 'for_allCC') {
        bus.$emit('daochuCCAll')
      }
    },
    compileCC() {   //编辑
    if(this.isActive == 'for_entrustNow') {
        bus.$emit('compileEntrustNow')
      } else if(this.isActive == 'for_entrustHis') {
        bus.$emit('compileEntrustHis')
      } else if(this.isActive == "for_mab") {
        bus.$emit("compileMab")
      } else if(this.isActive == 'for_cc') {
        bus.$emit('compileCC')
      } else if(this.isActive == 'for_allCC') {
        bus.$emit('compileAllCC')
      }
    },
    // compileEntrust() {
    //   if(this.isActive == 'for_entrustNow') {
    //     bus.$emit('compileEntrustNow')
    //   } else if(this.isActive == 'for_entrustHis') {
    //     bus.$emit('compileEntrustHis')
    //   } else if(this.isActive == "for_mab") {
    //     bus.$emit("compileMab")
    //   }
    // },
    changeCCFlag(flag){
      this.daochuCCFlag = flag
    },
    changeEntrustFlag(flag){
      this.daochuEntrustFlag = flag
    },
    changeDaochuMab(flag) {
      this.daochuMabFlag = flag
    },
    changeToken(params){
      let {id, type} = params
      this.dialogPassword = true
      this.ids = id
      this.type = type  
    },
    changeTitle(){
      let str = ''
      let allStr = ''
      let flag = true
      this.subNos.forEach((item, index) => {
        if(this.sub) {
          if(item.subAccountNo == this.sub) {
            str = item.subAccountBusinessName
          }
        } else {
          if(index < 3) {
            str += item.subAccountBusinessName + '、'
            flag = false
          }
        }
        allStr += item.subAccountBusinessName + '、'
      })
      
      if(!flag) {
        str += '...'
      }
      this.title = "远期业务(" + str + ")"
      this.allTitle = allStr
    },
    back(){
      this.$router.replace("/more?reselection=true")
    },
    goIndex(){
      this.$router.replace('/')
    },
    checkPass() {
      axios.post("clientbind/checkTradePassword.do", this.qs.stringify({
        clientBindId: this.ids,
        // tradePassword: Base64.encode(this.tradePassword)
        tradePassword: this.encryption(this.tradePassword)
      })).then(result => {
        if(result.data.success) {
          window.sessionStorage.setItem("token", result.data.FORWARD_TRADE_TOKEN)
          // window.sessionStorage.setItem("token", "Bearer " + result.data.FORWARD_TRADE_TOKEN)
          this.dialogPassword = false
          this.tradePassword = ''
          // 重新验证过交易密码后重复之前的操作
          switch(this.type) {
            case 'xiadan':
              bus.$emit('retryPay')
              break;
            case 'close':
              bus.$emit('retryClose')
              break;
            case 'repeal':
              bus.$emit('retryRepeal')
              break;
            case 'AllClose':
              bus.$emit('retryAllClose')
            case 'oneClose':
              bus.$emit("retryOneClose")
            case 'payClose': 
              bus.$emit("retryPayClose")
          }
        }
      })
    },
    getSubNos(){
      axios.post('client/inner/subaccount/queryAll.do').then(result => {
        if(result.data.success) {
          this.subNos = result.data.subAccountInfos
          this.changeTitle()
        }
      })
    },
    getPresent() {     //获取最近交易日
      axios.post('client/inner/businessinfo/query.do').then(result => {
        if(result.data.success) {
          let info = result.data.businessInfo
          let tradingDay = info.tradingDay  
          this.tradingDay = tradingDay
          window.sessionStorage.setItem("preCloseDate", info.closeDate)
        }
      })
    },
    getUser() {   //获取该账号下的线下账户集合
      return new Promise((reslove, reject) => {
        axios.post('client/queryClientBinds.do').then(result => {
          if (result.data.success) {
            let arr = result.data.clientBindsList
            this.userName = ''    //当前交易的线下账户名称
            arr.forEach(item => {
              if(item.id == this.id) {
                this.userName = item.companyNameInner
              }
            })
            reslove()
          }
        })
      })   
    },
    changeSubNo(subAccountNo) {
      let arr = this.subNos.filter((item) => {
        return item.subAccountNo == subAccountNo
      })
      return arr[0].subAccountBusinessName
    },
    getMoney() {
      axios.post('client/account/query.do', this.qs.stringify({
          webClientBindId: this.id
        })).then(data => {
          // 如果报错会axios响应拦截器会返回false
          if (!data) {
            return
          }
          let usable = data.data.clientAccount.balance
          let baozhengjin = data.data.clientAccount.margin
          let dongjiebaozheng = data.data.clientAccount.frozenMargin

          this.datas[0]['usable'] = usable
          this.datas[0]['margin'] = baozhengjin
          this.datas[0]['freezeMargin'] = dongjiebaozheng
        })
    },

    staticProfit() {      //静态权益, 暂时不用
      let usable = this.datas[0]['usable']
      let positionProfit = this.datas[0]['positionProfit']
      let freeze = this.datas[0]['freezeMargin']
      return this.add(this.add(usable, positionProfit), freeze)
    },
    dynPrifit() {         //动态权益
      let usable = this.datas[0]['usable']
      let float = this.datas[0]['float']
      let freeze = this.datas[0]['freezeMargin']
      return this.add(this.add(usable, float), freeze)
    },
    risk() {
      let a = this.dynPrifit()
      let positionMargin = this.datas[0]['positionMargin']
      let freeze = this.datas[0]['freezeMargin']
      let b = this.add(positionMargin, freeze)
      a ? a : 0
      b ? b : 0
      let n = this.mul(this.division(b, a), 100).toFixed(2)
      return isNaN(n) ? 0 : n
    },

  // 处理表单数据
    // 买持仓盈亏（浮）= 持仓手数 * 最新价 * 合约乘数 - 买期初成交价持仓市值(逐笔)
    // 卖持仓盈亏（浮）= 买期初成交价持仓市值(逐笔) - 持仓手数 * 最新价 * 合约乘数
    float(obj){
      let price = 0   //实时价格
      let futuresMultiple = obj.futuresMultiple   //合约乘数

      let buyNum = obj.buyContractVolume    //买持仓数量
      let sellNum = obj.sellContractVolume   //卖持仓数量
      let buyPosition = Number(obj.buyOriginalPriceContractValue)    //买期初成交价持仓市值(逐笔)
      let sellePosition = Number(obj.sellOriginalPriceContractValue)     //卖期初成交价持仓市值(逐笔)
      // 通过标的和子账获取最新价格
      this.socketData.forEach(item => {
        if(item.market == obj.exchange && item.code == obj.underlying && item.subAccountNo == obj.subAccountNo) {
          price = Number(item.price)
        }
      })
      let buy = Math.round(price * futuresMultiple * buyNum - buyPosition)
      let sell = Math.round(sellePosition - price * futuresMultiple * sellNum)
      let float = buy + sell
      return float
    },
    // 买持仓盈亏（盯市）= 最新价 * 持仓数量 * 合约乘数 - 买持仓市值(盯市)
    // 卖持仓盈亏（盯市）= 买持仓市值(盯市) - 最新价 * 持仓数量 * 合约乘数
    floatF(obj){
      let price = 0   //实时价格
      let futuresMultiple = obj.futuresMultiple   //合约乘数

      let buyNum = obj.buyContractVolume    //买持仓数量
      let sellNum = obj.sellContractVolume   //卖持仓数量

      let buyContractValue = obj.buyContractValue    //买持仓市值(盯市)
      let sellContractValue = obj.sellContractValue   //卖持仓市值(盯市)
      // 通过标的和子账获取最新价格
      this.socketData.forEach(item => {
        if(item.market == obj.exchange && item.code == obj.underlying && item.subAccountNo == obj.subAccountNo) {
          price = Number(item.price)
        }
      })
      let buy = price * buyNum * futuresMultiple - buyContractValue
      let sell = sellContractValue - price * sellNum * futuresMultiple
      let float = buy + sell
      return float
      
    },
    round(val) {
      return Number(val).toFixed(2)
    },

    calculateColl() {     //计算汇总持仓数据
      let underlyingGather = []     //用于储存标的与交易所值
      this.positionData.forEach(item => {
        let EU = item.exchange + '_' + item.underlying + "_" + item.subAccountNo
        this.$set(item, 'EU', EU)
        underlyingGather.push(EU)
      })
      underlyingGather = [...new Set(underlyingGather)]
      let classifyGather = {}     //造一个对象用于存放同标的和同交易所的数据
      underlyingGather.forEach(key => {
        classifyGather[key] = []

        this.positionData.forEach(item => {
          if(item.EU === key) {
            classifyGather[key].push(item)
          }
        })
      })
      let collectPositionData = []      //平仓数据在成交数据中获取 
      underlyingGather.forEach(key => {
        let obj = this.clone(GlobalConfig.collectPositionObject)
        let keyData = classifyGather[key]
        obj.exchange = keyData[0].exchange
        obj.underlying = keyData[0].underlying
        obj.subAccountName = keyData[0].subAccountBusinessName ? keyData[0].subAccountBusinessName : this.changeSubNo(keyData[0].subAccountNo)
        obj.subAccountNo = keyData[0].subAccountNo
        obj.EU = keyData[0].exchange + '_' + keyData[0].underlying + "_" + keyData[0].subAccountNo
        obj.futuresMultiple = keyData[0].futuresMultiple
        obj.buyAveragePriceValue = this.collAveragePrice(keyData, 'B')     //买持仓均价(按手 计算)
        obj.sellAveragePriceValue = this.collAveragePrice(keyData, 'S')     //卖持仓均价(按手 计算)
        obj.buyAveragePriceValueByUnit = this.division(obj.buyAveragePriceValue, obj.futuresMultiple)     //买持仓均价(按单位计算)
        obj.sellAveragePriceValueByUnit = this.division(obj.sellAveragePriceValue, obj.futuresMultiple)     //买持仓均价(按单位计算)
        
      
        let inventoryInfo = this.inventoryClassify(keyData)
        obj.buyHistoryDayRemainCloseVolume = inventoryInfo.buyHistoryDayRemainCloseVolume
        obj.sellHistoryDayRemainCloseVolume = inventoryInfo.sellHistoryDayRemainCloseVolume
        obj.buyTodayDayRemainCloseVolume = inventoryInfo.buyTodayDayRemainCloseVolume
        obj.sellTodayDayRemainCloseVolume = inventoryInfo.sellTodayDayRemainCloseVolume
        // obj.buyTodayOpenVolume = inventoryInfo.buyTodayOpenVolume
        // obj.sellTodayOpenVolume = inventoryInfo.sellTodayOpenVolume

        obj.buyUseable = obj.buyHistoryDayRemainCloseVolume + obj.buyTodayDayRemainCloseVolume
        obj.sellUseable = obj.sellHistoryDayRemainCloseVolume + obj.sellTodayDayRemainCloseVolume

        keyData.forEach(item => {
          if(item.buySell === 'B') obj.buyContractVolume += item.positionVolume
          if(item.buySell === 'S') obj.sellContractVolume += item.positionVolume

          obj.buyContractValue += this.marketValue(item, 'B')        //买持仓市值(盯市)  用于计算平仓盈亏盯市
          obj.sellContractValue += this.marketValue(item, 'S')       //卖持仓市值(盯市)  用于计算平仓盈亏盯市

        })
        obj.buyOriginalPriceContractValue = this.mul(obj.buyContractVolume, obj.buyAveragePriceValue)
        obj.sellOriginalPriceContractValue = this.mul(obj.sellContractVolume, obj.sellAveragePriceValue)
        obj.netValue = Math.abs(obj.buyContractVolume - obj.sellContractVolume)
        obj.floatValue = this.float(obj)
        obj.floatFValue = this.floatF(obj)
        
        collectPositionData.push(obj)
      })

      // this.entrustData.forEach(entrust => {       //从委托数据中统计今日开仓数量
      //   let EU = entrust.exchange + '_' + entrust.underlying + "_" + this.sub
      //   this.$set(entrust, 'EU', EU)
      //   if(entrust.openClose === 'O') {
      //     collectPositionData.forEach(c => {
      //       if(c.EU === entrust.EU) {
      //         if(entrust.buySell === 'B') {
      //           let n = c.buyTodayOpenVolume + entrust.tradeVolume
      //           this.$set(c, "buyTodayOpenVolume", n)
      //         } else if(entrust.buySell === 'S') {
      //            let n = c.sellTodayOpenVolume + entrust.tradeVolume
      //           this.$set(c, "sellTodayOpenVolume", n)
      //         }
      //       }
      //     })
      //   }
      // })

      // 成交数据计算持仓平仓信息
      this.mabData.forEach((item, index) =>{
        let EU = item.exchange + '_' + item.underlying + "_" + this.sub
        this.$set(item, 'EU', EU)

        if(item.openClose === 'C') {
          collectPositionData.forEach(list => {
            if(list.EU === item.EU) {
              if(item.buySell === 'B') {
                let n = list.buyTodayCloseVolume + item.tradeVolume
                this.$set(list, "buyTodayCloseVolume", n)
              } else if(item.buySell === 'S') {
                 let n = list.sellTodayCloseVolume + item.tradeVolume
                this.$set(list, "sellTodayCloseVolume", n)
              }
            }
          })

          let tradePrice = item.tradePrice      //成交价
          let num = item.tradeVolume      //成交手数
          var originalPrice = 0    //进场价(如果为今开今平则进场价为开仓成交价)
          var preSettlementPrice = 0      //前结算价 用于计算盯市持仓盈亏 老仓取前结算价, 今仓还取买开成交价
          var futuresMultiple = 0     //合约乘数
          if(!classifyGather[item.EU]) {
            return
          }
          classifyGather[item.EU].forEach(msg => {
            if(msg.contractNo === item.contractNo) {
              originalPrice = msg.originalPrice
              futuresMultiple = msg.futuresMultiple
              if(item.offsetFlag === 51 && item.exchange === 'SHFE' || item.offsetFlag === 51 && item.exchange === 'INE') {
                preSettlementPrice = msg.originalPrice      //盯市持仓盈亏,老仓去前结算价, 今仓还取买开成交价
              } else {
                // preSettlementPrice = this.socketObject[item.EU].pre_settlement_price
                preSettlementPrice = this.socketObject[msg.EU] ? this.socketObject[msg.EU].pre_settlement_price ? this.socketObject[msg.EU].pre_settlement_price : this.socketObject[msg.EU].price : 0
              }
            }
          })  
        
          var profit = this.mul(this.mul(this.minus(tradePrice, originalPrice), futuresMultiple), num)         //逐笔持仓盈亏
          var marketProfit = this.mul(this.mul(this.minus(tradePrice, preSettlementPrice), futuresMultiple), num)     //盯市持仓盈亏
          // console.log(tradePrice, originalPrice, futuresMultiple, preSettlementPrice)
          if(item.buySell === 'B') {     //买平为负, 买平为正
            profit = -profit 
            marketProfit = -marketProfit      
          } 
          collectPositionData.forEach(n => {
             if(n.EU === item.EU) {
              //  console.log(n, n.closeOutLossZValue, profit)
               this.$set(n, 'closeOutLossZValue', this.add(n.closeOutLossZValue, profit))
               this.$set(n, 'closeOutLossValue', this.add(n.closeOutLossValue, marketProfit))
             }
          })
        } else {
          collectPositionData.forEach(c => {
            if(c.EU === item.EU) {
              if(item.buySell === 'B') {
                let n = c.buyTodayOpenVolume + item.tradeVolume
                this.$set(c, "buyTodayOpenVolume", n)
              } else if(item.buySell === 'S') {
                 let n = c.sellTodayOpenVolume + item.tradeVolume
                this.$set(c, "sellTodayOpenVolume", n)
              }
            }
          })
        }
      })

      this.collectPositionData = collectPositionData
      return new Promise((reslove, reject) => {reslove()})
    },

    inventoryClassify(datas) {       //将今仓和历史仓持仓量和开仓量计算并累加
      let today = this.timeFormat()
      let obj = {
        buyHistoryDayRemainCloseVolume: 0,
        sellHistoryDayRemainCloseVolume: 0,
        buyTodayDayRemainCloseVolume: 0,
        sellTodayDayRemainCloseVolume: 0,
        // buyTodayOpenVolume: 0,     //今日开仓从成交数据中获取, 因为平仓会导致开仓记录从持仓明细中消除
        // sellTodayOpenVolume: 0,
      }
      datas.forEach(item => {
        let createTimeValue = this.timeFormat(new Date(item.createTime))

        if(item.buySell === 'B') {
          if(createTimeValue === today) {
            // obj.buyTodayOpenVolume += item.positionVolume
            obj.buyTodayDayRemainCloseVolume += item.remainCloseVolume
          } else {
            obj.buyHistoryDayRemainCloseVolume += item.remainCloseVolume
          }
        }
        
        if( item.buySell === 'S') {
          if(createTimeValue === today) {
            // obj.sellTodayOpenVolume += item.positionVolume
            obj.sellTodayDayRemainCloseVolume += item.remainCloseVolume
          } else {
            obj.sellHistoryDayRemainCloseVolume += item.remainCloseVolume
          }
        }
      })
      return obj
    },

    collAveragePrice(datas, buySell) {      //计算期权持仓汇总时均价的计算, 二个参数一个为要计算标的的集合对象, 第二个参数为买卖方向
      let futuresMultiple = datas[0].futuresMultiple
      let totalPrice = 0
      let amount = 0
      datas.forEach(item => {
        if(item.buySell == buySell) {
          totalPrice += this.mul(item.originalPrice, item.positionVolume)
          amount += item.positionVolume
        }
      })
      if(!amount) return 0
      return this.division(this.mul(totalPrice, futuresMultiple), amount).toFixed(2)
      // return this.division(totalPrice, amount).toFixed(2)
    },

    marketValue(msg, buySell) {
      let createTimeValue = this.timeFormat(new Date(msg.createTime)), today = this.timeFormat()
      let futuresMultiple = msg.futuresMultiple
      let price = 0     //如何为今仓价格就为进场价, 历史仓价格为前结算价
      let num = 0 
      if(createTimeValue === today) {
        price = msg.originalPrice
      } else {
        if(this.socketObject) {
          // if(!this.socketObject[msg.EU]) return this.marketValue(msg, buySell)
          price = this.socketObject[msg.EU] ? this.socketObject[msg.EU].pre_settlement_price ? this.socketObject[msg.EU].pre_settlement_price : this.socketObject[msg.EU].price : 0
        }
      }

      if(msg.buySell === buySell) {
        num = msg.positionVolume
      }
      return this.mul(this.mul(price, futuresMultiple), num)
      // return this.mul(price, num)
    },
    detectionPriceChange(msg) {     //检测相同的标的看价格是否改变
      this.collectPositionData.forEach((list, index) => {
        if(list.exchange === msg.market && list.underlying === msg.code) {
          let data = this.clone(list)
          data.floatValue = this.float(list)
          data.floatFValue = this.floatF(list)
          this.$set(this.collectPositionData, index, data)
          if(this.isActive == 'for_allCC') {
            this.innerShowData = this.collectPositionData
          }
        }
      })
      // this.socketData.forEach((item, i) => {
      //   if(item.market === msg.market && item.code === msg.code && item.price !== msg.price) {
      //     // let c = this.clone(item)
      //     // c.price = msg.price
      //     // this.$set(this.socketData, i, item)
      //     this.collectPositionData.forEach((list, index) => {
      //       if(list.exchange === msg.market && list.underlying === msg.code) {
      //         let data = this.clone(list)
      //         data.floatValue = this.float(list)
      //         data.floatFValue = this.floatF(list)
      //         this.$set(this.collectPositionData, index, data)
      //         if(this.isActive == 'for_allCC') {
      //           this.innerShowData = this.collectPositionData
      //         }
      //       }
      //     })
      //   }
      // })
    },


    clear(){
      if(this.moneyTimer) {
        clearInterval(this.moneyTimer)
        this.moneyTimer = null
        this.clearData()
      }
    },
    clearData() { 
      this.socketData = []
      this.positionData = []
      this.entrustData = []
      this.mabData = []
      this.settlePosition = []
      this.collectPositionData = []
      this.innerShowData = []
      // this.orderShowData = []
      this.firstPosition = true
      this.socketObject = null
      this.isActive = 'for_allCC'

      this.datas = [
        {
          positionMargin: 0,    //持仓保证金, 用于结算风险度
          positionProfit: 0,    //盯市持仓盈亏
          closeProfit: 0,
          float: 0,     //浮动盈亏(持仓)
          usable: 0,
          freezeMargin: 0,
          margin: 0,
        }
      ]
    },
    clearTransactionData() {
      this.positionData = []
      this.entrustData = []      //期权委托数据
      this.mabData = []      //期权成交数据
      this.settlePosition = []     //盘前持仓
      this.collectPositionData = []
      this.innerShowData = []
      // this.orderShowData = []
    },
    changeVersions() {
      let params = this.$route.query
      this.$router.push(`/forwardType?id=${params.id}&sub=${params.sub}&user=${params.user}`)
    },
    changeLayout() {
      let params = this.$route.query
      this.$router.push(`/newForword?id=${params.id}&sub=${params.sub}&user=${params.user}`)
    },
    isClass(val) {
      if(val > 0) {
        return 'red'
      } else {
        return 'green'
      }
    },
  },
  components: {
    left_exchange,
    right_details,
    for_content,
    for_cc,
    for_allCC,
    for_entrustNow,
    for_entrustHis,
    for_mab,

    exchange_socket,
  },
  watch: {
    $route:{
      handler(to, from) {
        if(to.path == "/newLayoutForword") {
          bus.$emit("leftExchange", 'all')
          this.sub = to.query.sub
          this.id = to.query.id
          this.user = to.query.user
          this.dis = to.query.dis
          this.getSubNos()
          this.getPresent()
          this.getUser()
          this.getHeight()
          if(this.sub && this.id) {
            this.getMoney()
            this.moneyTimer = setInterval(() => {
              this.getMoney()
            }, 60000)
          }
        } else {
          this.clear()
        }
      },
      immediate: true
    },
    positionData: {
      handler(newValue, oldValue) {
        if(!newValue.length) return
        let positionMargin = 0
        newValue.forEach(item => {
          positionMargin += item.positionMargin
        })
        this.datas[0]['positionMargin'] = positionMargin

        if(this.antiShake) {      //防抖, 一秒钟之内只会去请求一次
          this.antiShake = false
          this.getMoney()
          setTimeout(() => {
            this.antiShake = true
          }, 1000)
        }
        
        if(!this.firstPosition) this.calculateColl()
        
        if(this.isActive == 'for_cc') this.innerShowData = this.clone(newValue).sort( function(x, y) { if(x.contractNo > y.contractNo) { return -1 } if(x.contractNo < y.contractNo) { return 1 } return 0 })
      },
      immediate: true
    },
    collectPositionData: {
      handler(newValue, oldValue) {
        if(!newValue.length) return
        let floatValue = 0
        let positionProfit = 0
        let closeProfit = 0
        newValue.forEach(item => {
          floatValue += item.floatValue
          positionProfit += item.floatFValue
          closeProfit += item.closeOutLossValue
        })
        this.datas[0]['positionProfit'] = positionProfit
        this.datas[0]['closeProfit'] = closeProfit
        this.datas[0]['float'] = floatValue

        if(this.isActive == 'for_allCC') this.innerShowData = newValue
      },
      immediate: true
    },
    entrustData: {
      handler(newValue, oldValue) {
        if(this.isActive === 'for_entrustNow') this.innerShowData = newValue
      },
      immediate: true
    },
    mabData: {
      handler(newValue, oldValue) {
        if(this.isActive === 'for_mab') this.innerShowData = newValue
      },
      immediate: true
    },
    socketData: {
      handler(newValue, oldValue) {
        if(!newValue.length) return
        if(this.firstPosition) {
          this.calculateColl().then(() => {
            this.innerShowData = this.collectPositionData
            this.firstPosition = false
          })
        }
      },
      immediate: true
    },
  },
  computed: {
    companyName() {
      return g.companyName
    },
    sys() {
      return g.system
    },
    headClass() {
      let sys = g.system
      if(sys == '') {
        return 'production-color'
      } else if(sys == '仿真环境') {
        return 'emulator-color'
      } else {
        return 'other-color'
      }
    },
    systemDescribe() {
      return g.systemDescribe
    },
    tableFields() {
      return this.$store.state.tableFields
    },
  },
}
</script>

<style>
#newForword {
  /* position: fixed;
  top: 0;
  left: 0; */
  width: 100%;
  min-width: 1500px;
  z-index: -1;
}
#newForword>header {
  height: 45px;
  font-size: 18px;
  text-align: center;
  border-bottom: 1px solid #ccc;
  box-shadow:1px 1px 1px #ddd;
  margin-bottom: 5px;
  position: relative;
}
#newForword>.infoStatus {
  /* height: 45px; */
  font-size: 18px;
  border-bottom: 1px solid #ccc;
  box-shadow:1px 1px 1px #ddd;
  margin-bottom: 5px;
  z-index: 1,
}
#newForword>.infoStatus th {
  padding: 0 !important;
}
#newForword>.infoStatus .el-table__empty-text {
  display: none;
}
#newForword>header>.title {
  width: 40px;
  overflow: hidden;
  position: absolute;
  left: 10px;
  top: 0;
  height: 40px;
}
#newForword>header>.title>img {
  height: 40px;
}



#newForword .content {
  height: 300px;
  margin: 0;
  padding: 0;
  z-index: 9;
}

#newForword>.content nav {
  padding: 5px;
  border: 1px solid #ddd;
  float: left;
  height: 300px;
}

#newForword>.content section {
  height: 300px;
  float: left;
}

#newForword>.content>.right_detail {
  width: 400px;
  height: 300px;
  float: left;
}

#newForword .hint {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

#newForword .cc {
  margin-top: 10px;
}

#newForword .head {
  background: #005780;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #fff;
}
#newForword .head .active {
  color: #e84784;
}
#newForword .head span {
  cursor: pointer;
}

#newForword .mab .head {
  text-align: center;
}

#newForword .entrust {
  height: 250px;
}
#newForword .mab {
  height: 250px;
  margin-top: 40px;
}
#newForword td {
  padding: 0 !important; 
}

#newForword .current-row > td {
  background: #409EFF !important;
}

#newForword .sysName {
  position: absolute;
  left: 50px;
  top: 2px;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
}

#newForword .sysName .sys {
  color: #f00;
  font-size: 12px;
}

</style>
